// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"525":"unslug","743":"lang-[request]"}[chunkId] + "." + {"525":"ff6e7831","743":"72e74676"}[chunkId] + ".js";
};